import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/create_tv',
  component: Layout,
  redirect: '/create_tv/index',
  name: 'CreateTV',
  meta: {
    title: '生成tv数据',
    i18n: 'route.tabbar',
    icon: 'i-ic:round-tab',
  },
  children: [
    {
      path: 'index',
      name: 'CreateTVIndex',
      component: () => import('@/views/tv/create_tv.vue'),
      meta: {
        title: 'JSX',
        menu: false,
        breadcrumb: false,
        activeMenu: '/create_tv',
      },
    },
  ],
}

export default routes
